import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Button } from "reactstrap";
import { SPEED_TEST_RESULT, USER_ROLES } from 'UTILS/Constants';
import { getMessage } from "CONFIG/i18n";

import { getSpeedTestParticipantId } from "REDUX/Selector/RoomMetaDataSelector";
import { selectCurrentParticipantUniqueId } from "REDUX/Selector/SessionSelector";
import { getAllParticipants } from "COMPONENTS/CommonComponents/Header/selectors"
import { getLastName, getFirstName, getOwnSpeedTestError } from "REDUX/Selector/UserSelector";
import { selectUserRole } from "COMPONENTS/Whiteboard/selectors";

import "./SpeedTest.less";

const SpeedTest = (props) => {
  const uniqueId = useSelector(selectCurrentParticipantUniqueId);
  const speedTestParticipantId = useSelector(getSpeedTestParticipantId);
  const ownSpeedTestError = useSelector(getOwnSpeedTestError);
  const participants = useSelector(getAllParticipants);
  const lastName = useSelector(getLastName);
  const firstName = useSelector(getFirstName);
  const userRole = useSelector(selectUserRole);

  const ownParticipant = participants.find((participant) => {
    return (uniqueId === participant.uniqueId)
  });

  useEffect(() => {
    console.log("mount SpeedTest");
    return () => {
      console.log("unmount SpeedTest");
    };
  }, []);

  const renderSpeedTestLoading = () => {
    return (
      <>
        <div className='speedTestTop'>
          <div className='speedTestResultContainer'>
            <div className='resultLabel'>
              {getMessage("CONNECTION_STATUS_PREVIEW")}: 
            </div>
            <div className='result'>
              {getMessage("SPEED_TEST_RUNNING")}
            </div>
          </div>
        </div>
        <div
          className='loader'
        >
          {/* spinner */}
        </div>
      </>
    )
  }

  const renderSpeedTestResults = () => {
    const { result, download, upload } = ownParticipant?.speedTest || {};
    let resultMessage;
    if (ownSpeedTestError) {
      // timeout
      const userName = lastName ? `${lastName} ${firstName}` : firstName;
      resultMessage = getMessage("SPEED_TEST_TIME_OUT_PREVIEW", { 
        userName: userName,
        speedTestTimeoutSeconds: window._env_.SPEED_TEST_TIMEOUT_MSEC / 1000,
      });
    } else if (result === -1) {
      // speed test error
      const userName = lastName ? `${lastName} ${firstName}` : firstName;
      resultMessage = getMessage("SPEED_TEST_FAILURE_MESSAGE_PREVIEW", {userName: userName});
    } else {
      resultMessage = result !== undefined && 
        getMessage(Object.keys(SPEED_TEST_RESULT).find((key) => {
          return (SPEED_TEST_RESULT[key] === result);
        }));
    }
    return (
      <>
        <div className='speedTestTop'>
          <div className='speedTestResultContainer'>
            <div className='resultLabel'>
              {getMessage("CONNECTION_STATUS_PREVIEW")}: 
            </div>
            <div className='result'>
              {resultMessage}
            </div>
          </div>
          {userRole === USER_ROLES.AGENT &&
            <Button
              className="rerunButton buttons btn-decline customBtn"
              disabled={props.isSpeedTestRunning}
              onClick={(e)=>{
                e.currentTarget.blur();
                props.handleRerunSpeedtTest();
              }}
            >
              {getMessage("RUN")}
            </Button>
          }
        </div>

        {ownSpeedTestError || result === -1 ?
          null:
        <>
          <div
            className="squareContainer"
          >
            {Object.keys(SPEED_TEST_RESULT)
            .filter((key) => {
              return (SPEED_TEST_RESULT[key] !== -1);
            })
            .map((item) => {
              const isOrange = typeof result === 'number' && (SPEED_TEST_RESULT[item] <= result);
              return (
                <div
                  key={item}
                  className={isOrange ? `square ${item}` : "square"}
                >
                  {/* Speed ​​test result display box */}
                  {getMessage(item)}
                </div>
              )
            })}
          </div>
          <div className="bitrate">
            {`${getMessage("DOWNLOAD")}: ${download || '--'} Mbps`}<br/>
            {`${getMessage("UPLOAD")}: ${upload || '--'} Mbps`}
          </div>        
        </>}

      </>
    )
  }

  return (
    <>
      <div 
        className="speedTestContainer"
      >
        {uniqueId === speedTestParticipantId ?
          renderSpeedTestLoading():
          renderSpeedTestResults()
        }
      </div>
    </>
  )
};

export default SpeedTest;
